import { EntityModel } from "./entity.model";
import { StudyAgreementModel } from "./study-agreement.model";


export interface StudyMobilityModel extends EntityModel {
    semester?: boolean;
    studyAgreement: StudyAgreementModel;
}
